import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-team',
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.scss']
})
export class TeamComponent implements OnInit {


  constructor() { }

  ngOnInit(): void {
  }

  dgIsShow = true;
  toggleDG() {
    this.dgIsShow = !this.dgIsShow;
    this.dtIsShow = true;
    this.dadjoIsShow = true;
    this.alainIsShow = true;
  }

  dtIsShow = true;
  toggleDT() {
    this.dtIsShow = !this.dtIsShow;
    this.dgIsShow = true;
    this.dadjoIsShow = true;
    this.alainIsShow = true;
  }

  dadjoIsShow = true;
  toggleDQDJO() {
    this.dadjoIsShow = !this.dadjoIsShow;
    this.dgIsShow = true;
    this.dtIsShow = true;
    this.alainIsShow = true;
  }

  codoIsShow = true;
  toggleCODO() {
    this.codoIsShow = !this.codoIsShow;
    this.edemIsShow = true;
    this.etudeIsShow = true;
    this.adamaIsShow = true;
  }

  etudeIsShow = true;
  toggleETUDE() {
    this.etudeIsShow = !this.etudeIsShow;
    this.codoIsShow = true;
    this.edemIsShow = true;
    this.adamaIsShow = true;
  }
  edemIsShow = true;
  toggleEDEME() {
    this.edemIsShow = !this.edemIsShow;
    this.codoIsShow = true;
    this.etudeIsShow = true;
    this.adamaIsShow = true;
  }

  adamaIsShow = true;
  toggleADAMA() {
    this.adamaIsShow = !this.adamaIsShow;
    this.codoIsShow = true;
    this.edemIsShow = true;
    this.etudeIsShow = true;
  }

  ciIsShow = true;
  toggleCI() {
    this.ciIsShow = !this.ciIsShow;
    this.maliIsShow = true;
    this.wassiIsShow = true;

  }

  maliIsShow = true;
  toggleMALI() {
    this.maliIsShow = !this.maliIsShow;
    this.ciIsShow = true;
    this.wassiIsShow = true;
  }

  wassiIsShow = true;
  toggleWASSI() {
    this.wassiIsShow = !this.wassiIsShow;
    this.maliIsShow = true;
    this.ciIsShow = true;
  }

  alainIsShow = true;
  toggleAlain() {
    this.alainIsShow = !this.alainIsShow;
    this.dgIsShow = true;
    this.dadjoIsShow = true;
    this.dtIsShow = true;
  }

  codjiaIsShow = true;
  toggleCODJIA() {
    this.codjiaIsShow = !this.codjiaIsShow;
    this.abouoIsShow = true;
    this.badingaIsShow = true;
    this.jeromeIsShow = true;
  }
  abouoIsShow = true;
  toggleABOUO() {
    this.abouoIsShow = !this.abouoIsShow;
    this.codjiaIsShow = true;
    this.badingaIsShow = true;
    this.jeromeIsShow = true;
  }
  badingaIsShow = true;
  toggleBADINGA() {
    this.badingaIsShow = !this.badingaIsShow;
    this.codjiaIsShow = true;
    this.abouoIsShow = true;
    this.jeromeIsShow = true;
  }

  jeromeIsShow = true;
  toggleJEROME() {
    this.jeromeIsShow = !this.jeromeIsShow;
    this.codjiaIsShow = true;
    this.abouoIsShow = true;
    this.badingaIsShow = true;
  }

}
